<template>
  <div class="main frame-home" id="home">
    <div class="frame-bg">
      <img class="frame-img" src="/assets/images/frame-home.webp" alt />
    </div>
    <div class="frame-overlay"></div>
    <leaves></leaves>
    <div class="frame-content container-fluid fade-in">
      <div class="frame-text">
        <h1 class="frame-heading mb-4">
          FIGHT FOR VALHALLA,<br />
          FEAST LIKE GODS!
        </h1>
        <p class="lead">
          Become a Warrior in Norse Land and fight with enemies.<br />
          Create a deck and build a strategy with unique NFTs<br />
          that lead you to victory.
        </p>
        <div class="play-button mt-5">
          <a @click="openPlayBox" class="btn btn-lg btn-primary"> Play Demo</a>
        </div>
        <div class="watch-trailer mt-3">
          <a @click="openSilentBox" class="btn btn-lg btn-success">
            Watch Trailer
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Leaves from '@/components/Leaves.vue';

export default {
  data() {
    return {
      slidePage: false,
      video: {
        src: 'https://www.youtube.com/watch?v=IM_4-XFeRyA',
        description: 'Sunken dreams II. by Arbebuk',
        autoplay: true,
        controls: false,
      },
      image: {
        src: '/assets/images/arena.webp',
      },
    };
  },
  mounted() {
    //
  },
  methods: {
    openSilentBox() {
      this.$silentbox.open(this.video);
    },
    openPlayBox() {
      this.$silentbox.open(this.image);
    },
  },
  components: {
    Leaves,
  },
};
</script>

<style lang="scss" scoped>
.frame-home {
  position: relative;
  overflow: hidden;
  .frame-bg {
    position: relative;
    left: 0;
    height: 100%;
    width: 100%;
    min-height: 100vh;
    .frame-img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      transition: transform 1s ease-in-out;
    }
    .frame-extention {
      position: absolute;
      left: 50%;
      height: 100%;
      top: 0;
      bottom: 0;
      object-fit: cover;
      object-position: left;
    }
    .img-front {
      z-index: 4;
    }
  }
  .frame-overlay {
    position: absolute;
    z-index: 3;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 2.5%,
      rgba(0, 0, 0, 0) 75%,
      rgba(0, 0, 0, 1) 100%
    );
  }

  .frame-content {
    position: absolute;
    z-index: 3;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    .frame-text {
      text-shadow: 0 0 5px rgb(0 0 0);
      padding-left: 3rem;
      margin-bottom: 10rem;
      @media (max-width: 1365.98px) {
        margin-bottom: 8rem;
      }
      @media (max-width: 1199.98px) {
        margin-bottom: 6rem;
      }
      .frame-heading {
        color: #ffeec2;
        text-transform: uppercase;
      }
    }
    @media (max-width: 767.98px) {
      justify-content: flex-start;
      .frame-text {
        padding-left: 1rem;
        margin-top: 10rem;
        p {
          margin-bottom: 0.5rem;
        }
      }
    }
  }

  .next-page {
    position: absolute;
    right: 1em;
    top: 50%;
    transform: translateY(-50%);
    line-height: 2;
    font-size: 1rem;
    font-size: max(1rem, 18px);
    z-index: 5;
    opacity: 1;
    @media (max-width: 767.98px) {
      top: 92%;
    }
    a {
      color: #ffeec2;
      text-decoration: none;
      display: flex;

      span {
        margin-right: 0.5rem;
      }

      &:hover {
        color: #fff;
      }
    }
  }

  .slide-left {
    left: -100vh;
    transition: left 0.5s ease-in-out;
  }
  .fade-out {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
  }
}
</style>
